import { observer } from "mobx-react-lite";
import { useStores } from "./use.store";
import { loadMap } from "@adactiveasia/adsign-map";
import { useEffect, useState } from "react";
import { refreshMedia } from "./services/mediaActions";

const Splashscreen = observer(() => {
  const { mapStore, mainStore } = useStores();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    loadAppData();
  }, []);

  const loadAppData = async () => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          clearInterval(progressInterval);
          return 90;
        }
        return prev + 10;
      });
    }, 100);

    await loadMap(mapStore).then(async () => {
      try {
        await refreshMedia(mapStore);
      } catch (error) {
        console.warn("Unable to refresh media data:", error);
      }

      clearInterval(progressInterval);

      let currentProgress = 90;
      const finalInterval = setInterval(() => {
        currentProgress += 1;
        setProgress(currentProgress);

        if (currentProgress >= 100) {
          clearInterval(finalInterval);
          setTimeout(() => {
            mainStore.setAppLoaded(true);
          }, 200);
        }
      }, 50);
    });
  };

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center gap-4">
      <div className="text-xl font-medium">Loading...</div>
      <div className="text-3xl font-bold">{progress}%</div>
      {/* Optional: Progress bar */}
      <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-blue-500 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
});

export default Splashscreen;
